import { motion, AnimatePresence } from 'framer-motion';
import { SignOut } from '@phosphor-icons/react';

import styles from './LogoutOverlay.module.css';

interface LogoutOverlayProps {
    visible: boolean;
}

export function LogoutOverlay({ visible }: LogoutOverlayProps) {
    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    className={styles.overlay}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.25 }}
                >
                    <motion.div
                        className={styles.content}
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.2, delay: 0.05 }}
                    >
                        <motion.div
                            className={styles.iconCircle}
                            animate={{ rotate: [0, -10, 10, -5, 5, 0] }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <SignOut size={28} weight="bold" />
                        </motion.div>
                        <p className={styles.text}>Cerrando sesion...</p>
                        <div className={styles.dots}>
                            <motion.span
                                className={styles.dot}
                                animate={{ opacity: [0.3, 1, 0.3] }}
                                transition={{ duration: 1, repeat: Infinity, delay: 0 }}
                            />
                            <motion.span
                                className={styles.dot}
                                animate={{ opacity: [0.3, 1, 0.3] }}
                                transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
                            />
                            <motion.span
                                className={styles.dot}
                                animate={{ opacity: [0.3, 1, 0.3] }}
                                transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
                            />
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
